export const machineThreeAPages = [
  {
    path: "/solutions/procurement-control-passport",
    kind: "solution",
    status: "CONTROLLED PILOT",
    title: "Procurement Control Passport",
    description:
      "Connect the reason, authority, supplier decision, order, receipt, exceptions and payment-ready evidence for one controlled purchase.",
  },
  {
    path: "/solutions/supplier-qualification",
    kind: "solution",
    status: "CONTROLLED PILOT",
    title: "Supplier qualification",
    description:
      "Configure risk, required evidence, review ownership, expiry and supplier status without outsourcing the organisation's judgement.",
  },
  {
    path: "/solutions/approved-supplier-list",
    kind: "solution",
    status: "CONTROLLED PILOT",
    title: "Approved Supplier List",
    description:
      "Retrieve the organisation's governed supplier status and qualification evidence with effective dates and attributable decisions.",
  },
  {
    path: "/solutions/procurement-internal-controls",
    kind: "solution",
    status: "CONTROLLED PILOT",
    title: "Procurement internal controls",
    description:
      "Apply organisation-defined evidence rules as warnings, blocks, escalations or authorised exceptions before payment-ready status.",
  },
  {
    path: "/standards/iso-9001-procurement-controls",
    kind: "standard",
    status: "EDUCATIONAL",
    title: "ISO 9001 procurement controls",
    description:
      "Educational evidence mapping for external-provider and purchasing controls. RAQOZ does not issue certification or an audit opinion.",
  },
  {
    path: "/standards/iso-13485-purchasing-controls",
    kind: "standard",
    status: "EDUCATIONAL",
    title: "ISO 13485 purchasing controls",
    description:
      "Educational purchasing and supplier-control evidence guidance, subject to the organisation's quality system and professional review.",
  },
  {
    path: "/standards/iso-27001-supplier-controls",
    kind: "standard",
    status: "EDUCATIONAL",
    title: "ISO/IEC 27001 supplier controls",
    description:
      "Educational mapping for supplier and procurement evidence. It is not a statement of conformity, certification or legal sufficiency.",
  },
  {
    path: "/for-internal-auditors",
    kind: "advisor",
    status: "EDUCATIONAL",
    title: "Procurement evidence for internal auditors",
    description:
      "Use attributable purchase evidence and explicit gaps without granting a reviewer transactional authority or implying independence.",
  },
  {
    path: "/industries/healthcare-procurement",
    kind: "vertical",
    vertical: "healthcare",
    status: "CONTROLLED PILOT",
    title: "Healthcare and diagnostics procurement",
    description:
      "Every critical purchase from an approved supplier, with the evidence to prove the purchasing decision.",
  },
  {
    path: "/industries/construction-procurement",
    kind: "vertical",
    vertical: "construction",
    status: "CONTROLLED PILOT",
    title: "Construction and project procurement",
    description:
      "From material indent to site receipt, keep every project purchase controlled and provable.",
  },
  {
    path: "/industries/hotels-resorts",
    kind: "vertical",
    vertical: "hospitality",
    status: "CONTROLLED PILOT",
    title: "Hotels and resorts procurement",
    description:
      "From department request to property receipt, keep each purchase approved, attributable and ready for evidence review.",
  },
  {
    path: "/industries/facilities-management",
    kind: "vertical",
    vertical: "facilities",
    status: "CONTROLLED PILOT",
    title: "Facilities and property procurement",
    description:
      "Control every site request and retain evidence of each material receipt or service completion.",
  },
] as const;

export type MachineThreeAPage = (typeof machineThreeAPages)[number];

export function machineThreeAPage(path: string) {
  const clean = path.replace(/\/+$/, "") || "/";
  return machineThreeAPages.find((page) => page.path === clean);
}
